import { I4BCellType, I4BColumnConfiguration } from './configurations';
import { getDefaultColumnsByConcept } from './default-columns.registry';
import { I4BBasicColumn, I4BColumn } from './definitions';
import { I4bCellConcept } from './enums';
import { HeaderType, I4BColumnHeader, I4BGrid, I4BGridOptions, TeamPlanningsGridData } from './models';
import { I4BColumnOptions } from './options';
import { I4BTeamPlanningsButtonColumn } from './definitions/i4b-team-plannings-button.column';

export const GET_DEFAULT_TEAM_PLANNINGS_COLUMNS_FOR_TEAM_PLANNINGS_VIEW = (): I4BColumn<I4BColumnHeader, I4BColumnConfiguration, I4BColumnOptions>[] => [
  new I4BBasicColumn(
    { displayName: 'NAME', type: HeaderType.BASIC },
    {
      id: 'name',
      isDefault: true,
      sortProperty: 'name',
      translationKey: 'IOT_DICTIONARY.NAME',
      concept: I4bCellConcept.TEAM_PLANNINGS,
      isLink: true,
      cell: { type: I4BCellType.BASIC_LINK, event: { type: 'navigate' } }
    },
    { order: 1 }
  ),
  new I4BBasicColumn(
    { displayName: 'ENTITY', type: HeaderType.BASIC },
    {
      id: 'entity.name',
      isDefault: true,
      sortProperty: 'entity.name',
      translationKey: 'IOT_DICTIONARY.ENTITY',
      concept: I4bCellConcept.TEAM_PLANNINGS,
      cell: { type: I4BCellType.BASIC }
    },
    { order: 2 }
  ),

  new I4BBasicColumn(
    { displayName: 'BUSINESS PROFILE', type: HeaderType.BASIC },
    {
      id: 'businessProfile.name',
      isDefault: true,
      sortProperty: 'businessProfile.name',
      translationKey: 'IOT_DICTIONARY.BUSINESS_PROFILE',
      concept: I4bCellConcept.TEAM_PLANNINGS,
      cell: { type: I4BCellType.BASIC },
      isLink: false
    },
    { order: 3 }
  ),

  new I4BBasicColumn(
    { displayName: 'TIMEZONE NAME', type: HeaderType.BASIC },
    {
      id: 'timezoneDetails.name',
      isDefault: true,
      sortProperty: 'timezoneDetails.name',
      translationKey: 'IOT_DICTIONARY.TIMEZONE',
      concept: I4bCellConcept.TEAM_PLANNINGS,
      cell: { type: I4BCellType.BASIC },
      isLink: false
    },
    { order: 5 }
  ),

  new I4BBasicColumn(
    { displayName: 'ROTATION MODE', type: HeaderType.BASIC },
    {
      id: 'rotationMode',
      isDefault: true,
      sortProperty: 'rotationMode',
      translationKey: 'IOT_DICTIONARY.ROTATION_MODE',
      concept: I4bCellConcept.TEAM_PLANNINGS,
      cell: { type: I4BCellType.BASIC, options: { capitalize: true } },
      isLink: false
    },
    { order: 6 }
  ),

  new I4BBasicColumn(
    { displayName: 'CREATED BY', type: HeaderType.BASIC },
    {
      translationKey: 'MASTER_VIEW_ENGINE.TABLE.HEADER_NAME.CREATED_BY',
      id: 'createdBy',
      isDefault: true,
      sortProperty: 'createdBy',
      concept: I4bCellConcept.TEAM_PLANNINGS,
      width: 165,
      cell: { type: I4BCellType.USER_CELL }
    },
    {
      order: 7
    }
  ),
  new I4BBasicColumn(
    { displayName: 'CREATED AT', type: HeaderType.BASIC },
    {
      translationKey: 'MASTER_VIEW_ENGINE.TABLE.HEADER_NAME.CREATED_AT',
      id: 'createdAt',
      isDefault: true,
      sortProperty: 'createdAt',
      concept: I4bCellConcept.TEAM_PLANNINGS,
      cell: { type: I4BCellType.DATE }
    },
    {
      order: 10
    }
  )
];

export class DefaultTeamPlanningsGrid implements I4BGrid<I4BGridOptions, TeamPlanningsGridData> {
  masterview = 'team-plannings';
  isDefault = true;
  isUserDefault = false;
  isAppDefault = true;
  name = null;
  userId = null;
  declare data: TeamPlanningsGridData;
  gridOptions: I4BGridOptions = {
    pageSize: 100,
    multipleSelection: false,
    autoRefresh: { enabled: false },
    buttonColumn: { enabled: true, className: new I4BTeamPlanningsButtonColumn() },
    gridSort: []
  };
  columns: I4BColumn<I4BColumnHeader, I4BColumnConfiguration, I4BColumnOptions>[] = [...getDefaultColumnsByConcept(this.masterview)];
}
